import React, { useEffect, useState, useMemo, useRef } from 'react'
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  TouchSensor, // 确保触摸支持
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  horizontalListSortingStrategy,
  useSortable,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { restrictToHorizontalAxis } from '@dnd-kit/modifiers';
import general, { redux } from '../../general'
import Dialog from '../../lib/Dialog'
import { Image, Popup, SearchBar } from 'antd-mobile'
import './css/NewCommunity.css'
import { useScroll } from 'ahooks';
import $, { data, type } from 'jquery'
import { NavLink } from '../../lib/Navigation';

export default function CommunityGames(props) {

  const [topranked_games, setToprankedGames] = useState([])
  const [game_list, setGameList] = useState([])
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [more, setMore] = useState(true)
  const [update, setUpdate] = useState(false)
  const [init, setInit] = useState(false)
  const ref = useRef()

  const emptyBase = [
    { id: 0, name: '未添加' },
    { id: 1, name: '未添加' },
    { id: 2, name: '未添加' },
    { id: 3, name: '未添加' },
    { id: 4, name: '未添加' },
  ];
  // useMemo 计算 empty 和 draggableItems（响应 topranked_games 变化）
  const empty = useMemo(() => {
    return topranked_games.length > 5 ? [] : emptyBase.slice(0, 5 - topranked_games.length);
  }, [topranked_games]);

  const draggableItems = useMemo(() => {
    return topranked_games.length > 5
      ? topranked_games.slice(0, 5)
      : topranked_games;
  }, [topranked_games]);

  // 固定项：empty 补充（后部分）
  const fixedItems = empty;

  // 传感器配置：支持长按拖动
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
        delay: 250,
      },
    }),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 250,
        tolerance: 5,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const oftenvisit = (parms = {}) => {
    if (loading) {
      return
    }
    let tmp = {
      game_name: parms.game_name || '',
      pagination: { count: 200000, page: 1 },
    };
    // if (parms.page) {
    //   tmp.pagination.page = parms.page;
    // }
    setLoading(true)
    Dialog.loading()
    general.axios.post('/oftenvisit', tmp)
      .finally(() => {
        Dialog.close()
      })
      .then(res => {
        const { status, data: { topranked_games, game_list, paginated } } = res.data;
        setLoading(false)
        setInit(true)
        if (status.succeed) {
          if (!parms.search) {
            setToprankedGames(topranked_games)
          }
          // parms.page && setPage(parms.page);
          setGameList(game_list);
          // setMore(paginated.more && game_list.length > 0);
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }

  useEffect(() => {
    if (props.visible) {
      oftenvisit({ page: 1 })
    }
  }, [props.visible])

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      setUpdate(true);
      setToprankedGames((games) => {
        const draggableLength = games.length > 5 ? 5 : games.length;
        const draggableSlice = games.slice(0, draggableLength);
        const oldIndex = draggableSlice.findIndex((item) => item.maiyou_gameid === active.id);
        const newIndex = draggableSlice.findIndex((item) => item.maiyou_gameid === over.id);
        const updatedDraggable = arrayMove(draggableSlice, oldIndex, newIndex);
        return [...updatedDraggable, ...games.slice(draggableLength)];
      });
    }
  };

  // 可拖拽的单个 Div 组件
  function SortableItem({ item }) {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({ id: item.maiyou_gameid });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      backgroundColor: isDragging ? 'transparent' : '#fff',
      touchAction: 'none', // 防止触摸冲突
      width: '20%',
      flex: '1', display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative', zIndex: isDragging ? 999 : 1
    };

    return (
      <div
        ref={setNodeRef}
        style={style}
        {...attributes}
        {...listeners}
      >
        <img height={54} src={item.game_image.thumb} alt="" />
        <div style={{ textAlign: 'center', paddingTop: '8px', fontSize: '13px', color: '#000', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%' }}>{item.game_name}</div>
        <div onClick={() => handleDelete(item)} style={{ position: 'absolute', top: '-5px', right: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img src="resources/251009/delete.png" alt="" height={16} />
        </div>
      </div>
    );
  }

  const handleTopClick = (item) => {
    if (item.is_topranked) {
      return
    }
    if (topranked_games.length >= 5) {
      Dialog.info('常逛游戏最多添加5个哦~')
      return
    }
    setUpdate(true);
    setToprankedGames([...topranked_games, item]);
    const updatedList = game_list.map(obj => {
      if (obj.maiyou_gameid == item.maiyou_gameid) {
        return {
          ...obj,
          is_topranked: true
        };
      }
      return obj;
    });
    setGameList(updatedList);
  }

  const handleDelete = (item) => {
    setUpdate(true);
    setToprankedGames((prev) => prev.filter((game) => game.maiyou_gameid !== item.maiyou_gameid));
    const updatedList = game_list.map(obj => {
      if (obj.maiyou_gameid == item.maiyou_gameid) {
        return {
          ...obj,
          is_topranked: false
        };
      }
      return obj;
    });
    setGameList(updatedList);
  }

  // const scroll = useScroll()
  // useEffect(() => {
  //   if (props.visible) {
  //     console.log(scroll, page * 74 * 20);
  //     if (scroll.top < -80) {
  //       oftenvisit({ page: 1 });
  //     }
  //     if (scroll.top + 50 > $(document).height() && more) {
  //       oftenvisit({ page: page + 1 });
  //     }
  //   }
  // }, [props.visible, scroll])

  // 计算所有 id 数组
  const allIds = useMemo(() => {
    if (!topranked_games || !Array.isArray(topranked_games)) {
      return [];
    }
    return topranked_games
      .filter(item => item && item.maiyou_gameid !== undefined)
      .map(item => item.maiyou_gameid);
  }, [topranked_games]);

  // 新增：将 id 数组用逗号拼接成字符串
  const allIdsString = useMemo(() => {
    return allIds.join(','); // 输出: "1,2,3"（空数组时 ""）
  }, [allIds]);

  const handleDone = () => {
    if (!update) {
      props.onClose()
      return;
    }
    Dialog.loading()
    general.axios.post('/saveVisitedGames', {
      games: allIdsString
    })
      .finally(() => {
        Dialog.close()
      })
      .then(res => {
        const { status } = res.data;
        if (status.succeed) {
          props.onClose()
          if (update) {
            redux.dispatch({
              type: 'update-topranked_games',
              data: {
                topranked_games: topranked_games
              }
            })
          }
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }

  const handleSearch = () => {
    oftenvisit({ game_name: ref.current.nativeElement.value, page: 1 , search: true })
  }

  return (
    <div>
      <Popup
        destroyOnClose={true}
        getContainer={document.getElementById('root')}
        visible={props.visible}
        onMaskClick={() => {
          props.onClose()
        }}
        onClose={() => {
          props.onClose()
        }}
        bodyStyle={{
          borderTopLeftRadius: '8px',
          borderTopRightRadius: '8px',
          padding: '0px 15px',
          backgroundColor: 'white',
        }}
      >
        <div>
          <div>
            <div style={{ position: 'sticky', top: '0', backgroundColor: 'white', zIndex: 10 }}>
              <div className="header" style={{ display: 'flex', alignItems: 'center', padding: '15px 0' }}>
                <div style={{ fontSize: '17px', fontWeight: '500', color: '#282828' }}>常逛游戏</div>
                <div style={{ fontSize: '13px', color: '#999', flex: '1', paddingLeft: '5px', position: 'relative', top: '1px' }}>拖动排序</div>
                <div onClick={handleDone} style={{ fontSize: '13px', color: 'var(--MainColor)' }}>完成</div>
              </div>

              <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragEnd={handleDragEnd}
                modifiers={[restrictToHorizontalAxis]}
              >
                <SortableContext items={draggableItems.map(item => item.maiyou_gameid)} strategy={horizontalListSortingStrategy}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {draggableItems.map(item => (
                      <SortableItem item={item} key={item.maiyou_gameid} />
                    ))}
                    {fixedItems.map((item, index) => (
                      <div key={`fixed-${item.id}-${index}`} style={{ cursor: 'not-allowed', flex: '1', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <img height={54} src={'resources/251009/empty.png'} alt="" />
                        <div style={{ textAlign: 'center', paddingTop: '8px', fontSize: '13px', color: '#999' }}>{item.name}</div>
                      </div>
                    ))}
                  </div>
                </SortableContext>
              </DndContext>

              <div className='community-hot-search-index' style={{ display: 'flex', alignItems: 'center', padding: '18px 0' }}>
                <SearchBar
                  ref={ref}
                  placeholder='输入想要搜索的游戏名称'
                  searchIcon={<img style={{ position: 'relative', top: '-1.5px' }} src='/resources/user/ss.png' alt='' height={14} />}
                  onlyShowClearWhenFocused={true}
                  style={{
                    '--height': '40px',
                    '--padding-left': '15px',
                    overflow: 'hidden',
                    flex: '1',
                    borderRadius: '20px',
                  }}
                ></SearchBar>
                <div onClick={handleSearch} style={{ color: 'var(--MainColor)', paddingLeft: '10px', fontSize: '15px' }}>搜索</div>
              </div>

            </div>
            <div id='hot-games' style={{ height: '50vh', overflow: 'scroll' }}>
              <div style={{ fontSize: '17px', fontWeight: '500', color: '#282828', paddingBottom: '15px' }}>热门游戏</div>
              {
                game_list.map(item => {
                  return <div key={item.maiyou_gameid} style={{ paddingBottom: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Image src={item.game_image.thumb} height={54} width={54} />
                      <div style={{ flex: '1', paddingLeft: '10px' }}>
                        <div style={{ fontSize: '16px', color: '#282828', fontWeight: '500' }}>{item.game_name}</div>
                        <div style={{ fontSize: '11px', color: '#666' }}>{item.speechcount_text}{item.nameRemark && <span> · {item.nameRemark}</span>}</div>
                      </div>
                      <NavLink onClick={() => handleTopClick(item)} style={{ padding: '3px 17px', borderRadius: '14px', backgroundColor: item.is_topranked ? 'white' : '#F3F3F3' }}>
                        <img src={'resources/251009/' + (item.is_topranked ? 'normal.png' : 'top.png')} alt="" width={15} /></NavLink>
                    </div>
                  </div>
                })
              }
              {init && game_list.length === 0 && <div style={{ paddingTop: '50px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}><img src="/resources/empty.png" alt="" height={150} />暂无数据</div>}
            </div>
          </div>
        </div>
      </Popup>
    </div>
  )
}
